import { doPost, doGet } from './Base';


const getCart = async () => {
  return await doGet('/cart');
};
const checkout = async (linkoln_subdomains, custom_domains, coupon_code) => {
    return await doPost('/checkout', {
        "linkoln_subdomains": linkoln_subdomains,
        "custom_domains": custom_domains,
        "coupon_code": coupon_code
    });
};

const checkCoupon = async (coupon_code) => {
    return await doPost('/check_coupon', {
        "coupon_code": coupon_code,
    });
};


export {checkout, getCart, checkCoupon};
export default getCart;
